import { MissingAgreementDataQueryVariables } from 'generated/resources/graphql'

import { useMissingAgreementData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/useMissingAgreementData'

import { MissingGrossSalariesBanner } from './Banner'
import { MissingGrossSalariesButton } from './ButtonWithModal'
import { CustomValues } from './types'

interface Props {
  type: 'banner' | 'button'
  customValues?: CustomValues
  variables: MissingAgreementDataQueryVariables
  fromComponent: string
}

export const MissingGrossSalaries = ({ type, customValues, variables, fromComponent }: Props) => {
  const data = useMissingAgreementData({
    variables,
  })

  if (data.loading || !data || !data.totalCount) return null

  if (type === 'banner') {
    return (
      <MissingGrossSalariesBanner
        data={data}
        variables={variables}
        customValues={customValues}
        fromComponent={fromComponent}
      />
    )
  }

  if (type === 'button') {
    return (
      <MissingGrossSalariesButton
        data={data}
        variables={variables}
        customValues={customValues}
        fromComponent={fromComponent}
      />
    )
  }
}
